module.exports = __webpack_public_path__ + "media/images/emblems/Niedergoesgen-blason-9398662cf4579dba8086cdae816eab2d.png";